import { cn } from '@planuze/ui';
import { useSupportContent } from '../../content/sections/support.js';

type ConnectionState = 'connecting' | 'open' | 'reconnecting' | 'closed';

/* Tom visual por estado do WS do chat de staff — puro layout (não é texto), fica fora do
   catálogo bilíngue. Verde = tempo real ativo; âmbar pulsando = (re)conectando; vermelho =
   sem tempo real. */
const PRESET: Record<ConnectionState, { readonly dot: string; readonly pulse: boolean }> = {
  open: { dot: 'bg-success', pulse: false },
  connecting: { dot: 'bg-warning', pulse: true },
  reconnecting: { dot: 'bg-warning', pulse: true },
  closed: { dot: 'bg-destructive', pulse: false },
};

/* Badge de saúde do realtime (ADR-0433): ponto colorido + rótulo do estado. Torna a
   estabilidade da conexão visível pro atendente. */
export function ConnectionBadge({ state }: { readonly state: ConnectionState }) {
  const copy = useSupportContent();
  const preset = PRESET[state];
  const label = copy.connectionBadge.states[state];
  return (
    <span
      role="status"
      className="inline-flex items-center gap-1.5 text-xs text-muted-foreground"
      title={label}
      aria-label={copy.connectionBadge.ariaLabel}
    >
      <span
        className={cn('size-2 rounded-full', preset.dot, preset.pulse && 'animate-pulse')}
        aria-hidden="true"
      />
      {label}
    </span>
  );
}
